import { render, staticRenderFns } from "./Noticeboard.vue?vue&type=template&id=7bfef376&scoped=true&"
import script from "./Noticeboard.vue?vue&type=script&lang=js&"
export * from "./Noticeboard.vue?vue&type=script&lang=js&"
import style0 from "./Noticeboard.vue?vue&type=style&index=0&id=7bfef376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfef376",
  null
  
)

export default component.exports